import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../components/partials/Breadcrumb";
import { BiCategory } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Field } from "formik";
import { GetProductCategory, Alerts } from "../../../../helpers";
import CKEditorField from "../../../../components/cmp/CKEditorField";
import MediaLibraryPopup from "../../../../components/cmp/MediaLibraryPopup";
import { FiEdit } from "react-icons/fi";
const breadcrumbs = [
  {
    id: 1,
    label: "Dashboard",
    link: "/",
  },
  {
    id: 2,
    label: "Categories",
    link: "/app/product/categories",
  },
  {
    id: 3,
    label: "Create New",
    link: "/app/product/categories/create",
  },
];

const CreateCategory = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [showMedia, setShowMedia] = useState(false);
  const [imageFile, setImageFile] = useState("");

  const getCategories = async () => {
    let resp = await GetProductCategory.getAllCategories();
    if (resp && resp.status) {
      setCategories(resp.data);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const { parent_category, name, description, short_description, cat_thumb, is_home } = values;
    const data = {
      ...(parent_category && parent_category.trim() !== ""
        ? { parent_id: parent_category }
        : {}),
      title: name,
      short_description,
      description,
      is_home: is_home,
      media_id: cat_thumb,
      meta_title: values.meta_title,
      meta_description: values.meta_description,
      meta_keywords: values.meta_keywords,
      // canonical_url: values.canonical_url,
      // robots: values.robots,
      // og_title: values.og_title,
      // og_description: values.og_description,
      // og_image: values.og_image,
      // twitter_title: values.twitter_title,
      // twitter_description: values.twitter_description,
      // twitter_image: values.twitter_image
    };



    let resp = await GetProductCategory.createCategory(data);
    if (resp && resp.status) {

      Alerts.alertMessage(resp.message, "top-right", "success");
      resetForm();
      setSubmitting(false);
      navigate("/app/product/categories/");
    } else {
      Alerts.alertMessage(resp.message, "top-right", "error");
    }
  };
  // const handleSelectImage = (image) => {
  //   setImageFile(image);
  //   setShowMedia(false);
  // };
  return (
    <>
  
      <div className="innerPageWrapper">
        <div className="container-fluid">
          <div className="page-title">
            <h2>
              <BiCategory /> Create Product Categories
            </h2>
            <Link to="/app/product/categories/" className="btn btn-success">
              <BiCategory /> Categories
            </Link>
          </div>

          <Formik
            initialValues={{
              name: "",
              short_description: "",
              description: "",
              parent_category: "",
              cat_thumb: null,
              is_home: false,
              meta_title: "",
              meta_description: "",
              meta_keywords: "",
              // canonical_url:  "",
              // robots:  "",
              // og_title:  "",
              // og_description:  "",
              // og_image:  "",
              // twitter_title: "",
              // twitter_description:  "",
              // twitter_image: "",
            }}
            validate={(values) => {
              const errors = {};
              if (!values.name) {
                errors.name = "Category name is required";
              }
              if (!values.description) {
                errors.description = "Category description is required";
              }
              if (!values.cat_thumb) {
                errors.cat_thumb = "Category thumbnail is required";
              }

              return errors;
            }}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => {
              const handleSelectImage = (image) => {
                console.log("Selected image:", image);
                setImageFile(image);
                setShowMedia(false);
                setFieldValue("cat_thumb", image.id); // safe now
              };

              return (
                <form onSubmit={handleSubmit}>
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          <div className="form-group">
                            <label>Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.name}
                            />
                            {errors.name && touched.name && (
                              <span className="help-error">{errors.name}</span>
                            )}
                          </div>

                          <div className="form-group">
                            <label>Short Description</label>
                            <textarea
                              className="form-control"
                              name="short_description"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.short_description}
                            ></textarea>
                            {errors.short_description &&
                              touched.short_description && (
                                <span className="help-error">
                                  {errors.short_description}
                                </span>
                              )}
                          </div>

                          <div className="form-group">
                            <label>Description</label>
                            <Field
                              name="description"
                              render={({ field, form }) => (
                                <CKEditorField field={field} form={form} />
                              )}
                            />
                            {errors.description && touched.description && (
                              <span className="help-error">
                                {errors.description}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Category Thumbnail</label>
                            <div className="dropzone-box">
                              {imageFile !== "" && (
                                <img
                                  src={imageFile.path}
                                  alt="product_thumbnail"
                                />
                              )}
                              {imageFile !== "" ? (
                                <button
                                  type="button"
                                  className="floatBtn"
                                  onClick={() => setShowMedia(true)}
                                >
                                  <FiEdit size={15} />
                                </button>
                              ) : (
                                <>
                                  <p>Drop files to upload</p>
                                  <p>or</p>
                                  <button
                                    type="button"
                                    onClick={() => setShowMedia(true)}
                                    className="choose-btn"
                                  >
                                    Choose file
                                  </button>
                                </>
                              )}
                            </div>
                            {errors.cat_thumb && touched.cat_thumb && (
                              <span className="help-error text-center">
                                {errors.cat_thumb}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <label>Parent Category</label>
                            <select
                              className="form-control"
                              name="parent_category"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.parent_category}
                            >
                              <option value={""}>---Select Category---</option>
                              {categories.length !== 0 &&
                                categories.map((item) => {
                                  return (
                                    <option value={item.id} key={item.id}>
                                      {item.title}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                          <div className="form-group">
                            <div className="form-check-custom col-md-12 mt-0">
                              <input
                                type="checkbox"
                                id="is_home"
                                name="is_home"
                                checked={values.is_home}
                                onChange={() => {
                                  setFieldValue("is_home", !values.is_home)
                                }}
                              />
                              <label htmlFor="is_home">
                                Show on Home
                              </label>
                            </div>

                          </div>
                          <div
                            style={{
                              width: "100%",
                              textAlign: "center",
                              marginTop: 50,
                            }}
                          >
                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "Submitting..." : "Submit"}
                            </button>
                          </div>
                        </div>
                      </div>
                      {showMedia && (
                        <MediaLibraryPopup
                          show={showMedia}
                          isMulti={false}
                          setShowMedia={setShowMedia}
                          handleImageSubmit={handleSelectImage}
                          setFieldValue={setFieldValue}
                          fieldName="cat_thumb"
                        />
                      )}
                    </div>
                  </div>
                <div className="card" style={{ marginTop: 20 }}>
                    <div className="card-header">
                      <h3>Search Engine Optimization</h3>
                    </div>
                    <div className="card-body">
                      <div class="mb-3">
                        <label for="metaTitle" class="form-label">Meta Title</label>
                        <input type="text" class="form-control" id="metaTitle" name="meta_title" placeholder="Enter meta title"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.meta_title}
                        />
                      </div>
                      <div class="mb-3">
                        <label for="metaDescription" class="form-label">Meta Description</label>
                        <textarea class="form-control" id="metaDescription" name="meta_description" rows="3" placeholder="Enter meta description"  onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.meta_description}></textarea>
                      </div>
                      <div class="mb-3">
                        <label for="metaKeywords" class="form-label">Meta Keywords</label>
                        <input type="text" class="form-control" id="metaKeywords" name="meta_keywords" placeholder="e.g. electronics, gadgets, accessories" onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.meta_keywords}/>
                      </div>
                      {/* <div class="mb-3">
                        <label for="canonicalUrl" class="form-label">Canonical URL</label>
                        <input type="text" class="form-control" id="canonicalUrl" name="canonical_url" placeholder="https://example.com/category" onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.canonical_url}/>
                      </div>
                      <div class="mb-3">
                        <label for="robots" class="form-label">Robots</label>
                        <input type="text" class="form-control" id="robots" name="robots" placeholder="index, follow" onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.robots}/>
                      </div>
                      <hr />
                      <h5 style={{marginBottom:10}}>Open Graph (Facebook)</h5>
                      <div class="mb-3">
                        <label for="ogTitle" class="form-label">OG Title</label>
                        <input type="text" class="form-control" id="ogTitle" name="og_title" placeholder="Enter OG title" onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.og_title}/>
                      </div>
                      <div class="mb-3">
                        <label for="ogDescription" class="form-label">OG Description</label>
                        <textarea class="form-control" id="ogDescription" name="og_description" rows="3" placeholder="Enter OG description"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.og_description}
                        ></textarea>
                      </div>
                      <div class="mb-3">
                        <label for="ogImage" class="form-label">OG Image URL</label>
                        <input type="text" class="form-control" id="ogImage" name="og_image" placeholder="https://example.com/image.jpg" 
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.og_image}
                        />
                      </div>
                      <hr />
                      <h5 style={{marginBottom:10}}>Twitter Card</h5>
                      <div class="mb-3">
                        <label for="twitterTitle" class="form-label">Twitter Title</label>
                        <input type="text" class="form-control" id="twitterTitle" name="twitter_title" placeholder="Enter Twitter title" 
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.twitter_title}
                        />
                      </div>
                      <div class="mb-3">
                        <label for="twitterDescription" class="form-label">Twitter Description</label>
                        <textarea class="form-control" id="twitterDescription" name="twitter_description" rows="3" placeholder="Enter Twitter description"  onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.twitter_description}></textarea>
                      </div>
                      <div class="mb-3">
                        <label for="twitterImage" class="form-label">Twitter Image URL</label>
                        <input type="text" class="form-control" id="twitterImage" name="twitter_image" placeholder="https://example.com/twitter-image.jpg" onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.twitter_image}/>
                      </div> */}
                    </div>
                  </div>

                </form>
              );
            }}
          </Formik>
        </div>


      </div>
    </>
  );
};

export default CreateCategory;
